import React from 'react';
import { BsWhatsapp } from 'react-icons/bs';

const Contact = () => {
  return (
    <div className="min-h-screen bg-slate-50 dark:bg-gray-950 flex flex-col items-center justify-center p-6 pt-24">
      <div className="max-w-md w-full bg-white dark:bg-gray-900 rounded-[2rem] shadow-2xl border border-slate-100 dark:border-gray-800 overflow-hidden p-8 md:p-10 text-center">
        <div className="h-16 w-16 bg-green-100 dark:bg-green-900/30 text-green-500 rounded-2xl flex items-center justify-center mx-auto mb-6 transform -rotate-6">
          <BsWhatsapp size={32} />
        </div>
        
        <h1 className="text-3xl font-extrabold text-slate-900 dark:text-white mb-4 tracking-tight">Let's Talk</h1>
        
        <p className="text-sm text-slate-500 dark:text-slate-400 mb-10 leading-relaxed">
          Need support with NIN, BVN, or IPE verifications? Our team is available right now on WhatsApp to help you out.
        </p>
        
        <a 
          href="https://wa.me/2349077968959" 
          target="_blank" 
          rel="noopener noreferrer"
          className="flex items-center justify-center gap-3 w-full bg-green-500 hover:bg-green-600 text-white font-bold py-4 px-6 rounded-xl transition-all shadow-lg shadow-green-500/30 hover:shadow-green-500/40 hover:-translate-y-1 active:translate-y-0"
        >
          <BsWhatsapp size={20} />
          Chat on WhatsApp
        </a>

        <div className="mt-8 text-xs font-semibold text-slate-400 dark:text-slate-500 uppercase tracking-widest">
          Average response time: &lt; 5 mins
        </div>
      </div>
    </div>
  );
};

export default Contact;
